import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = {
  key: 1,
  class: "row fw-bold text-center"
}
const _hoisted_3 = {
  class: "info-section",
  style: {"margin":"2px 0","padding":"8px","border":"2px solid #17a2b8","border-radius":"10px","background-color":"#e7f3ff"}
}
const _hoisted_4 = { class: "container border-1" }
const _hoisted_5 = { class: "border-1" }
const _hoisted_6 = { class: "border-1" }
const _hoisted_7 = { class: "border-1 text-center m-0 p-0" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["src", "onClick", "title"]
const _hoisted_10 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_11 = { class: "border-1 text-left" }
const _hoisted_12 = { class: "custom-file-input" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["type", "accept", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!$setup.loggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "h1 text-danger" }, " You first need to log into your account. ", -1)
        ]))]))
      : _createCommentVNode("", true),
    ($setup.loggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "fw-bold h4 mb-3" }, "📄 Document Upload Portal", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "h5" }, " (JPG, JPEG, PNG & GIF allowed with max 3MB size) ", -1)),
            ($setup.uploadStatusMessage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass($setup.uploadStatusClass),
                  style: {"padding":"8px","border-radius":"4px","margin-top":"10px"}
                }, _toDisplayString($setup.uploadStatusMessage), 3))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("table", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "border-1 bg-primary" }, [
                _createElementVNode("td", { class: "border-1 text-center" }, "Name"),
                _createElementVNode("td", { class: "border-1 text-center" }, "Uploaded"),
                _createElementVNode("td", { class: "border-1 text-left" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documentsConfig, (doc) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: doc.key,
                  class: "border-1"
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(doc.displayName), 1),
                  _createElementVNode("td", _hoisted_7, [
                    ($setup.getIconUrl(doc.key))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("img", {
                            src: $setup.getIconUrl(doc.key),
                            style: {"width":"40px","height":"40px","object-fit":"contain","border-radius":"4px","cursor":"pointer"},
                            onClick: ($event: any) => ($setup.downloadDocument(doc.key)),
                            title: 'Click to download ' + doc.displayName
                          }, null, 8, _hoisted_9)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, "NO"))
                  ]),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      (!$setup.getIconUrl(doc.key))
                        ? (_openBlock(), _createElementBlock("label", {
                            key: 0,
                            class: "custom-file-label",
                            onClick: ($event: any) => ($setup.triggerFileInput(doc.key))
                          }, " Upload " + _toDisplayString(doc.isPdf ? 'PDF' : 'Image'), 9, _hoisted_13))
                        : _createCommentVNode("", true),
                      _createElementVNode("input", {
                        type: doc.isPdf ? 'file' : 'file',
                        accept: doc.isPdf ? '.pdf' : 'image/*',
                        ref_for: true,
                        ref: el => $setup.setFileInputRef(doc.key, el),
                        style: {"display":"none"},
                        onChange: ($event: any) => (doc.isPdf ? $setup.handlePDFFileChange(doc.key, $event) : $setup.handleFileChange(doc.key, $event))
                      }, null, 40, _hoisted_14)
                    ])
                  ])
                ]))
              }), 128)),
              _cache[3] || (_cache[3] = _createElementVNode("tr", null, [
                _createElementVNode("a", { href: "https://emergingsolsdownloads.blob.core.windows.net/applications/app-release.apk" }, "download android App")
              ], -1))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}